import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var StageEvent = /** @class */ (function (_super) {
    __extends(StageEvent, _super);
    function StageEvent(type, stage) {
        var _this = _super.call(this, type) || this;
        _this._stage = stage;
        return _this;
    }
    Object.defineProperty(StageEvent.prototype, "stage", {
        /**
         *
         */
        get: function () {
            return this._stage;
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     */
    StageEvent.prototype.clone = function () {
        return new StageEvent(this.type, this._stage);
    };
    /**
     *
     */
    StageEvent.STAGE_ERROR = 'stageError';
    /**
     *
     */
    StageEvent.CONTEXT_CREATED = 'contextCreated';
    /**
     *
     */
    StageEvent.CONTEXT_DISPOSED = 'contextDisposed';
    /**
     *
     */
    StageEvent.CONTEXT_RECREATED = 'contextRecreated';
    /**
     *
     */
    StageEvent.INVALIDATE_SIZE = 'invalidateSize';
    return StageEvent;
}(EventBase));
export { StageEvent };
